import { Button, Modal } from '@teo/components';
import { useTranslation } from 'react-i18next';
import { useEffect } from 'react';

const ComponentDeleteModal = ({
  closeModal,
  setIsOpenDeleteModal,
  title,
  heading,
  text,
  handleDelete,
  children,
  modalClassName,
  deleteDisabled,
}: any) => {
  const { t } = useTranslation();

  useEffect(() => {
    const handleKeyDown = (e: KeyboardEvent) => {
      if (e.key === 'Escape') {
        closeModal();
      }
    };

    window.addEventListener('keydown', handleKeyDown);

    return () => {
      window.removeEventListener('keydown', handleKeyDown);
    };
  }, [closeModal]);

  return (
    <div className="bg-white">
      <div className="fixed inset-0 z-[100] flex rounded-xl bg-white/75 px-3">
        <div
          className={`mx-auto my-8 flex h-max max-h-[calc(100vh-4rem)] w-full flex-col rounded-xl bg-white drop-shadow-m ${
            modalClassName || 'max-w-lg'
          }`}
        >
          <Modal.Header onClose={closeModal}>
            <h2 className="text-sm font-semibold">{title}</h2>
          </Modal.Header>

          <Modal.Body>
            <div className="flex flex-col gap-5">
              <div>
                <h3 className="mb-3 text-lg">{heading}</h3>
                {text && (
                  <p
                    className="text-base text-grey-06"
                    dangerouslySetInnerHTML={{ __html: text }}
                  />
                )}
              </div>
              {children}
            </div>
          </Modal.Body>
          <Modal.Footer
            cancelButtonLabel={t('button.cancel')}
            onCancel={() => setIsOpenDeleteModal(false)}
          >
            <Button
              variant="destruct"
              disabled={deleteDisabled}
              onClick={() => handleDelete()}
            >
              {t('button.delete')}
            </Button>
          </Modal.Footer>
        </div>
      </div>
    </div>
  );
};

export default ComponentDeleteModal;
